import { useEffect } from 'react'

import { Link } from 'react-router-dom'

import {
  AlertSensitiveInfo,
  TextSpan,
} from 'app/components/design-system-components'
import Box from 'app/components/design-system-components/Box'
import { fontSizes } from 'app/components/design-system-components/styles/variables'
import theme from 'app/match/applicationReportPDF/assets/theme'
import LoginFacebook from 'app/session/register_components/register_facebook'
import { history } from 'app/shared_components/router'
import { urlTo } from 'app/sm/helpers'

export const ProfileItemScreen = ({ children }: any) => (
  <div className="two-col-box-flex-row sm64">
    <div className="col-first">{children}</div>
  </div>
)

export const ProfileItem = ({ children, linkUrl, haveData }: any) => {
  const style = 'bc-hub-item-link' + (haveData ? ' have-data' : '')
  return (
    <Link className={style} to={linkUrl}>
      {children}
    </Link>
  )
}

export const ProfileItemHeader = ({ iconStyle, text }: any) => {
  return (
    <header>
      <i className={iconStyle} />
      <span>{text}</span>
    </header>
  )
}

export const ProfileItemContent = ({ children }: any) => {
  const ContentTag = 'content' as any
  return <ContentTag className="display-flex">{children}</ContentTag>
}

export const ProfileAvatar = ({ currentUser }: any) => (
  <div className="cell-m pt5 pr20">
    {currentUser.avatar ? (
      <div
        className="avatar abatar-big"
        style={{ backgroundImage: `url(${currentUser.avatar})` }}
      />
    ) : (
      <div className="avatar blue-bg fs24">
        {currentUser.firstName
          ? currentUser.firstName.charAt(0).toUpperCase()
          : ''}
        {currentUser.lastName
          ? currentUser.lastName.charAt(0).toUpperCase()
          : ''}
      </div>
    )}
  </div>
)

const ProfileAccountInfo = ({ currentUser }: any) => (
  <div>
    {currentUser && currentUser.firstName + ' ' + currentUser.lastName}
    <br />
    {currentUser && currentUser.email}
    <br />
    {currentUser && currentUser.mobile}
  </div>
)

const ProfileAccount = ({
  currentUser,
  fetchRentalHistory,
  fetchCards,
  clearRentalBackUrl,
  addRentalReputationBackUrl,
  setBackUrl,
}: any) => {
  useEffect(() => {
    fetchRentalHistory()
    fetchCards()
    clearRentalBackUrl()
    addRentalReputationBackUrl(urlTo('BCProfile'))
    setBackUrl('')
  }, [])

  return (
    <ProfileItemScreen>
      <div className="rental-notification display-flex">
        <span className="btn btn-transparent btn-left rental-header-mobile-layout width-auto align-items-center">
          <span onClick={() => history.push(urlTo('homeoverview'))}>
            My Home
            <i className="icon-arrow-right" />
          </span>
        </span>
        <span className="btn btn-transparent btn-left rental-header-mobile-layout width-auto align-items-center">
          <span>User Account</span>
        </span>
      </div>
      <div className="table">
        <div className="cell-m-100 pt30">
          <TextSpan
            as="div"
            fontSize={fontSizes[11]}
            fontWeight={theme.fontWeights.h2}
            mb={5}
          >
            User Account
          </TextSpan>
          <div className="mt20">
            <p>Manage your user account.</p>
          </div>
          <AlertSensitiveInfo />
        </div>
      </div>

      <div
        className={currentUser.userType === 'facebook' ? 'mt50 mb20' : 'hidden'}
      >
        <LoginFacebook form="You are logged in" disabled="disabled" />
      </div>

      <Box mt={7}>
        <ProfileItem linkUrl="#" haveData={true}>
          <ProfileItemHeader iconStyle="icon-person" text="Account" />
          <ProfileItemContent>
            <ProfileAvatar currentUser={currentUser} />
            <ProfileAccountInfo currentUser={currentUser} />
          </ProfileItemContent>
          <div
            className={currentUser.userType === 'facebook' ? 'hidden' : ''}
          />
          <div className="change-password-card">
            {!currentUser.isOffshore && (
              <>
                <Link to={urlTo('UpdateProfile')} className="mr8">
                  <button className="textButton height20">
                    Update Details
                  </button>
                </Link>
              </>
            )}
            <Link to={urlTo('ChangePassword')}>
              <button className="textButton height20">Change password</button>
            </Link>
          </div>
          <div />
        </ProfileItem>
      </Box>
    </ProfileItemScreen>
  )
}

export default ProfileAccount
